/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Row_IdlocalInputs */

const en_cmp_row_idlocal = /** @type {(inputs: Cmp_Row_IdlocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesian language & payments`)
};

const id_cmp_row_idlocal = /** @type {(inputs: Cmp_Row_IdlocalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa & pembayaran Indonesia`)
};

/**
* | output |
* | --- |
* | "Indonesian language & payments" |
*
* @param {Cmp_Row_IdlocalInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_row_idlocal = /** @type {((inputs?: Cmp_Row_IdlocalInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Row_IdlocalInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_row_idlocal(inputs)
	return en_cmp_row_idlocal(inputs)
});